import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClientTimesheetActivitiesModal from "../clientTimesheetActivities/ClientTimesheetActivitiesModal";
import ClientTimesheetEmployeesModal from "../clientTimesheetEmployees/ClientTimesheetEmployeesModal";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../../request/Postrequest";
import {
  FETCH_CLIENT_EMP_JOBS,
  FETCH_CLIENT_TIMESHEET_TEMPLATES_V2,
  SAVE_CLIENT_TIMESHEET_TEMPLATE
} from "../../../constant/Apipath";
import { LoadingButton } from "@mui/lab";
import Loader from "../../../common/Loader";
import SearchIcon from "@mui/icons-material/Search";
import SelectJob from "../clientTimesheetJobModel/SelectJob";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";

let CLIENT_ACCENT_COLOR = "#000000";
export default function CrewTemplateForm({
  isOpen,
  onClose,
  timeSheetData,
  setModelState,
  from,
  templateId
}) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;
  const TOKEN = loginData?.accessToken;
  const USER_ID = loginData?.userInformation?.UserId;

  const {
    TEXT_TEMPLATE_NAME,
    TEXT_JOB,
    TEXT_SEARCH_JOB,
    TEXT_ACTIVITIES,
    TEXT_SELECT_ACTIVITIES,
    TEXT_EMPLOYEES,
    TEXT_SELECT_EMPLOYEES,
    TEXT_NAME_PALCEHOLDER,
    TEXT_SAVE
  } = ClientEnglishFallback?.CrewTemplateForm(multiLanguageData?.CrewTemplateForm || {});

  const { TEXT_SELECT_JOB } = ClientEnglishFallback.SelectJobModal(
    multiLanguageData?.SelectJobModal || {}
  );

  const [clientJobList, setClientJobList] = useState([]);
  const [templateName, setTemplateName] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [selectActivity, setSelectActivity] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [loader, setLoader] = useState(true);
  const [openJob, setOpenjob] = useState(false);

  const [activityList, setActivityList] = useState([]);
  const [employeesList, setEmployeesList] = useState([]);
  const [selectEmployees, setSelectEmployees] = useState(false);
  const [selectActivities, setSelectActivities] = useState(false);

  const [fromJob, setFromjob] = useState(false);
  const [openEmployee, setOpenemployee] = useState(false);

  useEffect(() => {
    if (isOpen) getData();
  }, [isOpen]);

  const getData = useCallback(async () => {
    await getClientJobs();
    if (templateId !== 0) {
      await getTemplateDetails();
    } else {
      if (from === "CrewTimesheet") {
        await getCrewtimesheetdetails();
      }
    }
    setLoader(false);
  }, []);

  const getClientJobs = async () => {
    try {
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: inputValue,
        UserId: USER_ID,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            clientEmployeeId: selectedClientData?.ClientEmployeeId,
            ClientId: selectedClientData?.ClientId,
            active: true
          }
        ],
        SortList: [{ FieldName: "dateModified", Direction: "DESC" }]
      };
      let clientJobRes = await Postrequestcall(FETCH_CLIENT_EMP_JOBS, obj, TOKEN);
      let data = clientJobRes?.data?.data;
      let temp = [];
      if (data.length > 0) {
        data.map((item) => {
          temp.push({
            ...item,
            clientJobCode: item.jobCode,
            clientJobName: item.name
          });
        });
        setClientJobList(temp);
      }
    } catch (error) {
      console.error("getClientJobs Error ", error);
    }
  };

  const getCrewtimesheetdetails = () => {
    if (timeSheetData?.timesheetActivitiesList?.length > 0) {
      setSelectActivity(true);
    }
    setSelectedValue({ ...timeSheetData, clientJobCodeId: timeSheetData?.clientJobId });
    setTemplateName("");
    setActivityList(
      timeSheetData?.timesheetActivitiesList?.map((item) => ({
        ...item,
        id: item?.clientActivityId,
        labourActivityCode: item?.clientJobActivityCode,
        labourActivityName: item?.clientJobActivityName
      })) || []
    );
    setEmployeesList(
      timeSheetData?.timesheetEmployeesList?.map((item) => ({
        ...item,
        id: item?.clientEmployeeId,
        firstName: item?.clientEmployeeName,
        lastName: ""
      })) || []
    );
    let job = `${timeSheetData?.clientJobCode} - ${timeSheetData?.clientJobName}`;
    setInputValue(job);
  };

  const getTemplateDetails = async () => {
    try {
      const fetchParams = {
        PageNr: 1,
        NrOfRecPerPage: 0,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: false,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            id: templateId
          }
        ]
      };
      const response = await Postrequestcall(
        FETCH_CLIENT_TIMESHEET_TEMPLATES_V2,
        fetchParams,
        loginData?.accessToken
      );
      if (response.status === 200) {
        setTemplateName(response?.data?.data[0]?.name);
        let temp = response?.data?.data[0];
        let job = `${temp?.clientJobCode} - ${temp?.clientJobName}`;
        setInputValue(job);
        if (temp?.noOfActivities > 0) {
          setSelectActivity(true);
        }
        setSelectedValue({ ...temp, clientJobCodeId: temp?.clientJobId });
        setTemplateName(temp?.name);
        setActivityList(
          temp?.templateActivitiesList?.map((item) => ({
            ...item,
            id: item?.activityId,
            labourActivityCode: item.activityCode,
            labourActivityName: item.activityName
          })) || []
        );
        setEmployeesList(
          temp?.templateEmployeesList?.map((item) => ({
            ...item,
            id: item?.clientEmployeeId,
            firstName: item.clientEmployeeName,
            lastName: ""
          })) || []
        );
      }
    } catch (error) {}
  };

  const handelTemplateSave = async () => {
    try {
      const save_Duplicate_Template_Object = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: templateId !== 0 ? templateId : 0,
            Name: templateName,
            Type: 1,
            ClientEmployeeId: selectedClientData?.ClientEmployeeId,
            ClientJobId: Number(selectedValue?.clientJobCodeId),
            EmployeeIdList: `${(employeesList?.map((emp) => emp.clientEmployeeId ?? emp.id) || []).join(",")}`,
            ActivityIdList: `${(activityList?.map((act) => act?.activityId ?? act.id) || []).join(",")}`,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };

      let getResponse = await Postrequestcall(
        SAVE_CLIENT_TIMESHEET_TEMPLATE,
        save_Duplicate_Template_Object,
        TOKEN
      );
      if (getResponse.status === 201) {
        if (from === "CrewTimesheet") {
          onClose();
        } else {
          onClose();
        }
      }
    } catch (error) {
      console.error("handelTemplateSave Error ", error);
    } finally {
    }
  };

  // const returnSelectedemp = () => {
  //   let getList = employeesList.map((item) => {
  //     return {
  //       ...item,
  //       id: item?.clientEmployeeId
  //     };
  //   });
  //   return getList;
  // };

  return (
    <>
      <Modal
        open={isOpen}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box
          sx={{
            padding: {
              xs: "10px",
              xl: "15px",
              lg: "15px",
              md: "15px",
              sm: "10px"
            },
            minHeight: "320px"
          }}
          className="client-modal-responsive">
          <Stack
            display={"flex"}
            justifyContent={"space-between"}
            alignItems={"center"}
            flexDirection={"row"}>
            <>
              {from === "" && (
                <IconButton
                  size="small"
                  onClick={() => {
                    setModelState("HOME");
                  }}>
                  <ArrowBackIcon />
                </IconButton>
              )}
              <IconButton size="small" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </>
          </Stack>
          <Stack
            sx={{
              minHeight: "300px",
              maxHeight: "500px",
              overflowY: "auto",
              scrollbarWidth: "none"
            }}
            gap={1}>
            {loader ? (
              <Stack
                alignItems={"center"}
                minHeight={"300px"}
                justifyContent={"center"}
                width={"100%"}>
                <Loader />
              </Stack>
            ) : (
              <>
                {" "}
                <Typography variant="body">{TEXT_TEMPLATE_NAME}</Typography>
                <TextField
                    onChange={(e) => {
                      let inputValue = e.target.value;
                      inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                      setTemplateName(inputValue);
                    }}
                  size="small"
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0"
                    },
                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                      padding: "0"
                    }
                  }}
                  value={templateName}
                  variant="outlined"
                  style={{
                    backgroundColor: "#e4e4e4",
                    borderRadius: "10px"
                  }}
                  placeholder={TEXT_NAME_PALCEHOLDER}
                />
                <Grid container spacing={1}>
                  <Grid size={12}>
                    <Typography>{TEXT_JOB}</Typography>
                    <TextField
                      placeholder={TEXT_SEARCH_JOB}
                      size="small"
                      sx={{
                        backgroundColor: "#e4e4e4",
                        borderRadius: "10px",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none"
                        }
                      }}
                      slotProps={{
                        input: {
                          readOnly: true,
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          )
                        }
                      }}
                      value={inputValue}
                      fullWidth
                      variant="outlined"
                      onClick={() => {
                        setOpenjob(true);
                      }}
                    />
                  </Grid>
                  <Grid
                    container
                    size={12}
                    sx={{
                      maxHeight: "400px",
                      overflow: "scroll",
                      scrollbarWidth: "none"
                    }}>
                    <Grid size={12}>
                      <Stack justifyContent="space-between" alignItems="center" direction="row">
                        <Typography fontWeight={"bold"}>{TEXT_ACTIVITIES}</Typography>
                        {activityList?.length != 0 && (
                          <Typography
                            onClick={() => {
                              if (
                                selectedValue?.clientJobCodeId !== 0 &&
                                typeof selectedValue?.clientJobCodeId !== "undefined"
                              ) {
                                setFromjob(false);
                                setSelectActivities(true);
                              } else {
                                alert(TEXT_SELECT_JOB);
                                setOpenjob(true);
                              }
                            }}
                            sx={{
                              cursor: "pointer",
                              color: CLIENT_ACCENT_COLOR
                            }}>
                            {TEXT_SELECT_ACTIVITIES}
                          </Typography>
                        )}
                      </Stack>
                      {activityList?.length == 0 && (
                        <Button
                          fullWidth
                          onClick={() => {
                            if (
                              selectedValue?.clientJobCodeId !== 0 &&
                              typeof selectedValue?.clientJobCodeId !== "undefined"
                            ) {
                              setFromjob(false);
                              setSelectActivities(true);
                            } else {
                              alert(TEXT_SELECT_JOB);
                              setOpenjob(true);
                            }
                          }}
                          sx={{
                            backgroundColor: CLIENT_ACCENT_COLOR,
                            color: "white",
                            borderRadius: "10px",
                            textTransform: "none"
                          }}>
                          {TEXT_SELECT_ACTIVITIES}
                        </Button>
                      )}
                      <Grid mt={1} container spacing={1}>
                        {activityList?.map((item, index) => {
                          return (
                            <ListingComponent
                              from={"activityList"}
                              activityList={activityList}
                              setActivityList={setActivityList}
                              key={index}
                              item={item}
                              index={index}
                            />
                          );
                        })}
                      </Grid>
                    </Grid>
                    <Grid size={12}>
                      <Stack justifyContent="space-between" alignItems="center" direction="row">
                        <Typography fontWeight={"bold"}>{TEXT_EMPLOYEES}</Typography>
                        {employeesList?.length != 0 && (
                          <Typography
                            onClick={() => {
                              setSelectEmployees(true);
                            }}
                            sx={{
                              cursor: "pointer",
                              color: CLIENT_ACCENT_COLOR,
                              marginTop: "10px"
                            }}>
                            {TEXT_SELECT_EMPLOYEES}
                          </Typography>
                        )}
                      </Stack>
                      {employeesList?.length == 0 && (
                        <Button
                          fullWidth
                          onClick={() => setSelectEmployees(true)}
                          sx={{
                            backgroundColor: CLIENT_ACCENT_COLOR,
                            color: "white",
                            borderRadius: "10px",
                            textTransform: "none"
                          }}>
                          {TEXT_SELECT_EMPLOYEES}
                        </Button>
                      )}
                      <Grid mt={1} container spacing={1}>
                        {employeesList?.map((item, index) => {
                          return (
                            <ListingComponent
                              from={"employeeList"}
                              employeesList={employeesList}
                              setEmployeesList={setEmployeesList}
                              key={index}
                              item={item}
                              index={index}
                            />
                          );
                        })}
                      </Grid>
                    </Grid>
                  </Grid>

                  <LoadingButton
                    fullWidth
                    disabled={
                      templateName == "" ||
                      activityList?.length === 0 ||
                      employeesList?.length === 0
                    }
                    onClick={() => {
                      handelTemplateSave();
                    }}
                    style={{ color: "white" }}
                    sx={{
                      marginTop: "10px",
                      backgroundColor:
                        templateName == "" ||
                        activityList?.length === 0 ||
                        employeesList?.length === 0
                          ? "#e4e4e4"
                          : CLIENT_ACCENT_COLOR,
                      color: "#ffff",
                      borderRadius: "10px",
                      "&:hover": {
                        backgroundColor: CLIENT_ACCENT_COLOR
                      }
                    }}>
                    {TEXT_SAVE}
                  </LoadingButton>
                </Grid>
              </>
            )}
          </Stack>
        </Box>
      </Modal>

      {openJob && (
        <SelectJob
          isOpen={openJob}
          onClose={() => setOpenjob(false)}
          setInputValue={setInputValue}
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
          setSelectActivities={setSelectActivities}
          setFromjob={setFromjob}
        />
      )}

      {selectEmployees && (
        <ClientTimesheetEmployeesModal
          setSelectedEmp={setEmployeesList}
          empList={employeesList}
          isOpen={selectEmployees}
          setSelectEmployees={setSelectEmployees}
          onClose={() => setSelectEmployees(false)}
        />
      )}

      {selectActivities && (
        <ClientTimesheetActivitiesModal
          setSelectedActivityList={setActivityList}
          isOpen={selectActivities}
          onClose={() => setSelectActivities(false)}
          jobId={selectedValue?.clientJobCodeId}
          actList={activityList}
          fromJob={fromJob}
          setOpenjob={setOpenjob}
          openEmployee={openEmployee}
          setOpenemployee={setOpenemployee}
          setSelectEmployees={setSelectEmployees}
        />
      )}
    </>
  );
}

const ListingComponent = ({
  item,
  employeesList,
  setEmployeesList,
  activityList,
  setActivityList,
  index,
  from
}) => {
  const deleteEmployee = (getItem) => {
    if (from === "employeeList") {
      let getUpdatelist = employeesList?.filter(
        (item) => item?.clientEmployeeId !== getItem?.clientEmployeeId
      ) || [];
      setEmployeesList(getUpdatelist);
    } else {
      let getUpdatelist = activityList?.filter((item) => item?.id !== getItem?.id) || [];
      setActivityList(getUpdatelist);
    }
  };

  return (
    <Grid
      size={12}
      spacing={1}
      sx={{
        border: "1px solid #e4e4e4",
        padding: "10px",
        borderRadius: "15px",
        cursor: "pointer"
      }}
      container
      key={index}
      style={{ display: "flex", justifyContent: "space-between" }}>
      <Grid size={12}>
        <Stack
          justifyContent={"space-between"}
          direction={"row"}
          alignItems={"center"}
          width={"100%"}>
          <Typography
            sx={{
              wordBreak: "break-all",
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 1,
              fontSize: "17px",
              fontWeight: "bold"
            }}>
            {from === "employeeList"
              ? item?.firstName + " " + (item?.lastName ? item?.lastName : "")
              : item?.labourActivityCode + " " + item.labourActivityName}
          </Typography>
          <IconButton size="small" onClick={() => deleteEmployee(item)}>
            <CloseIcon
              sx={{
                color: CLIENT_ACCENT_COLOR
              }}
            />
          </IconButton>
        </Stack>
      </Grid>
    </Grid>
  );
};
